





































































import { Vue, Component, Prop } from 'vue-property-decorator'
import PopupState from './popup-state.vue'
import appPermission from './appPermission'

@Component({
  name: 'PopupPermission',
  components: {
    PopupState
  }
})
export default class extends Vue {
  @Prop({ required: true })
  info!: object

  appPermission = Object.freeze(appPermission)
  defaultProps = {
    children: 'children',
    label: 'label'
  }
}
